import { Injectable, ComponentFactoryResolver, ApplicationRef, Injector, EmbeddedViewRef, ComponentRef } from '@angular/core';
import { EmployerUserModalComponent } from '@app/components/employer-user-modal/employer-user-modal.component';

@Injectable()
export class InjectorModalService {

    modalRef: ComponentRef<EmployerUserModalComponent>;


    constructor(

        private resolver: ComponentFactoryResolver,
        private appRef: ApplicationRef,
        private injector: Injector
    ) { }

    openModal() {
        // Crear un componente dinámicamente
        const factory = this.resolver.resolveComponentFactory(EmployerUserModalComponent);
        this.modalRef = factory.create(this.injector);
        // this.modalRef.instance.

        // Adjuntar el componente al DOM
        this.appRef.attachView(this.modalRef.hostView);

        // Añadir el componente al body del DOM
        const domElem = (this.modalRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
        document.body.appendChild(domElem);

        this.modalRef.instance.getUserEmployer();

        // Manejar el evento de cierre del modal
         this.modalRef.instance.closeModalEvent.subscribe(() => {
           this.closeModal();
         });
    }

    private closeModal() {
        if (this.modalRef) {
            this.appRef.detachView(this.modalRef.hostView);
            this.modalRef.destroy();
        }
    }

}
